import React from "react";

const StatCard = ({ label, value, helper, accent = "indigo" }) => {
  const accentClasses = {
    indigo: "bg-indigo-50 text-indigo-700",
    emerald: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    blue: "bg-blue-50 text-blue-700",
    rose: "bg-rose-50 text-rose-700",
    slate: "bg-slate-100 text-slate-700",
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <div
        className={[
          "mb-3 inline-flex rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide",
          accentClasses[accent] || accentClasses.indigo,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {label}
      </div>
      <div className="text-2xl font-semibold text-slate-900">{value}</div>
      {helper && <p className="mt-2 text-sm text-slate-500">{helper}</p>}
    </div>
  );
};

export default StatCard;
